<div class="whitebox pricecheckform pricecheck-box">
  <form [formGroup]="form" role="form">
    <div class="row">

      <div class="col-md-6">
        <h3>Preisprüfung</h3>
      </div>
      <div class="col-md-6 text-right">
        @if ('debugging.calc'|HasPerm) {
          <a uiSref="a.price.debug_console" target="_blank">
            Preis Konsole
          </a>
        }
      </div>

      <div class="col-md-12">
        <div class="pricecheck-box-col-20">
          <div class="form-group">
            <input [inputSelect] class="form-control" formControlName="quantity" id="pricecheck-quanity" min="0"
              placeholder="Menge" type="number">
          </div>
        </div>
        <div class="pricecheck-box-col-20">
          <div class="form-group">
            <input [inputSelect] class="form-control" formControlName="release" id="pricecheck-release" min="0"
              placeholder="Freigabe" type="number">
          </div>
        </div>
        <div class="pricecheck-box-col-20">
          <div class="form-group">
            <button type="button"
              class="btn btn-primary"
              style="width: 100%;"
              [disabled]="lock"
              (click)="calculate(true)">
              <i class="fa fa-refresh"></i>
            </button>
          </div>
        </div>
        <div class="pricecheck-box-col-20">
          <div class="form-group">
            @if (responseData.german && ('price.change'|HasPerm) && !blockSave) {
              <button (click)="save('de')" class="btn btn-success" style="width: 100%;"
                type="button">
                DE
              </button>
            }
          </div>
        </div>
        <div class="pricecheck-box-col-20">
          <div class="form-group">
            @if (responseData.china && ('price.change'|HasPerm) && !blockSave) {
              <button (click)="save('cn')" class="btn btn-success" style="width: 100%;"
                type="button">
                CN
              </button>
            }
          </div>
        </div>
      </div>

    </div>

    <div class="row">
      <div class="w-1/2 float-left pl-4 pr-4">
        <div class="whitebox-inner storzgreen min-h-80">
          <h3>Deutschland</h3>
          <div class="grid gap-1">
            <div class="2xl:grid-rows-subgrid 2xl:row-span-2 2xl:col-start-1 pl-2 pr-2">
              <div>
                <label for="pricecheck-calc-quanity">Kalk-Me:</label>
              </div>
              <div>
                <input [inputSelect] class="form-control" formControlName="calc_quantity_de"
                       id="pricecheck-calc-quanity" type="number">
                @if (!responseData.calc_quantity_found) {
                  <span class="red_alert">
                  Kalk-Me nicht gefunden!
                </span>
                }
              </div>
            </div>

            <div class="2xl:grid-rows-subgrid 2xl:row-span-2 2xl:col-start-2 pl-2 pr-2 2xl:w-20">
              <div>
                <label for="pricecheck-lose-de">Lose:</label>
              </div>
              <div>
                <input [inputSelect] class="form-control" formControlName="lose_de"
                       id="pricecheck-lose-de" type="number">
              </div>
            </div>

            <div class="2xl:grid-rows-subgrid 2xl:row-span-2 2xl:col-start-3 pl-2 pr-2">
              <div>
                <label for="id_germany">Kalk:</label>
              </div>
              <div>
                <select class="form-control" formControlName="calc_de" id="id_germany" name="germany">
                  <option [ngValue]="null" label="deaktivieren"></option>
                  <option label="manuell" value="manuell">Manuell</option>
                  @for (obj of processes.de; track obj) {
                    @if (!obj.hidden || form.value['calc_de'] === obj.name) {
                      <option [value]="obj.name">
                        {{ obj.name }}
                      </option>
                    }
                  }
                </select>
              </div>
            </div>

            <div class="2xl:grid-rows-subgrid 2xl:row-span-2 2xl:col-start-3 2xl:row-start-3 pl-2 pr-2">
              <div>
                <label for="pricecheck-de-price"><strong>Einzel:</strong></label>
              </div>
              <div>
              <span class="input-group">
                <input [inputSelect] class="form-control" formControlName="price_de"
                       id="pricecheck-de-price" type="text">
                <span class="input-group-addon" id="basic-addon">€</span>
              </span>
              </div>
            </div>
          </div>

          <div class="grid gap-1">
            <div class="2xl:grid-rows-subgrid 2xl:row-span-2 2xl:col-start-1">
              <div>
                <label>Gesamt:</label>
              </div>
              <div>
                @if (responseData.german) {
                  <span>{{ responseData.german.total_price }} €</span>
                }
              </div>
            </div>

            <div class="2xl:grid-rows-subgrid 2xl:row-span-2 2xl:col-start-2">
              <div>
                <label>Nebenk.:</label>
              </div>
              <div>
                @if (responseData.german) {
                  <span>{{ responseData.german.tooling }} €</span>
                }
              </div>
            </div>

            <div class="2xl:grid-rows-subgrid 2xl:row-span-2 2xl:col-start-3">
              <div>
                <label>Adapterk.:</label>
              </div>
              <div>
                @if (responseData.german) {
                  <span>{{ responseData.german.adapter }} €</span>
                }
              </div>
            </div>

            <div class="2xl:grid-rows-subgrid 2xl:row-span-2 2xl:col-start-4">
              <div>
                <label>Goldpr.:</label>
              </div>
              <div>
                @if (article.data.surface_area === 'Chem NI / AU') {
                  @if (goldPrice.data$|async; as goldPriceView) {
                    <span [title]="`Goldpreis am ${goldPriceView.date|date:'dd.MM.yyyy'}:
                                  ${goldPriceView.price_raw|money:2}€/g`">
                  {{ goldPriceView.price_per_lp|money:2 }} € / LP
                </span>
                  } @else {
                    <ng-template [ngTemplateOutlet]="loadingOrError.template"></ng-template>
                  }
                  <loading-or-error
                    #loadingOrError
                    [loadingWrapper]="goldPrice"
                    errorMessage="Gold konnte nicht geprüft werden"
                    [spinnerSize]="2"
                    spinnerName="circle-o-notch">
                  </loading-or-error>
                } @else {
                  <span>Kein ENiG</span>
                }
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="w-1/2 float-left pl-4 pr-4">
        <div class="whitebox-inner storzblue min-h-80">
          <h3>China</h3>

          <div class="pricecheck-box-row">
            <div class="pricecheck-box-col" style="width:60px;">
              <div class="form-group">
                <label>Kurs:</label>
                <input [inputSelect] class="form-control" formControlName="exchange_rate"
                  id="pricecheck-exchange-rate" type="text">
              </div>
            </div>
            <div class="pricecheck-box-col" style="width: 50px;">
              <div class="form-group">
                <label for="pricecheck-lose-cn">Lose:</label><br>
                <input [inputSelect] class="form-control" formControlName="lose_cn"
                  id="pricecheck-lose-cn" type="number">
              </div>
            </div>

            <div class="pricecheck-box-col" style="width: 100px;">
              <div class="form-group">
                <label>Kalk:</label><br>
                <select class="form-control" formControlName="calc_cn" id="id_china" name="china">
                  <option [ngValue]="null" label="deaktivieren"></option>
                  <option label="manuell" value="manuell">Manuell</option>
                  @for (obj of processes.cn; track obj) {
                    @if (!obj.hidden || form.value['calc_cn'] === obj.name) {
                      <option [value]="obj.name">
                        {{ obj.name }}
                      </option>
                    }
                  }
                </select>
              </div>
            </div>
            <div class="pricecheck-box-col" style="width: 85px;">
              <div class="form-group ">
                <label for="pricecheck-cn-price"><strong>Einzel:</strong></label><br>
                <span class="input-group">
                  <input [inputSelect] class="form-control" formControlName="price_cn"
                    id="pricecheck-cn-price" type="text">
                  <span class="input-group-addon" id="basic-addon2">€</span>
                </span>
              </div>
            </div>
          </div>
          <div class="pricecheck-box-row">

            <div class="pricecheck-box-col" style="width: 90px;">
              <div class="form-group ">
                <label>Gesamt:</label><br>
                @if (responseData.china) {
                  <span>{{ responseData.china.total_price }} €</span>
                }
              </div>
            </div>
            <div class="pricecheck-box-col" style="width: 75px;">
              <div class="form-group">
                <label>Nebenk.:</label><br>
                @if (responseData.china) {
                  <span>{{ responseData.china.tooling }} €</span>
                }
              </div>
            </div>
            <div class="pricecheck-box-col" style="width: 75px;">
              <div class="form-group">
                <label>Kalk-Me:</label><br>
                @if (responseData.china) {
                  <span>{{ responseData.china.calc_quanity }}</span>
                }
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <article-weight [oaNr]="article.oa_nr" [amount]="form.value.quantity"></article-weight>
  </form>
</div>
